$(document).ready(function() {
    $("#show_hide_password a").on('click', function(event) {
        event.preventDefault();
        if($('#show_hide_password input').attr("type") == "text"){
            $('#show_hide_password input').prop('type', 'password');
            $('#show_hide_password i').addClass( "icon-eye-slash" );
            $('#show_hide_password i').removeClass( "icon-eye" );
        }else if($('#show_hide_password input').attr("type") == "password"){
            $('#show_hide_password input').prop('type', 'text');
            $('#show_hide_password i').removeClass( "icon-eye-slash" );
            $('#show_hide_password i').addClass( "icon-eye" );
        }
    });
});
